import React from 'react'
import { Box } from '@material-ui/core'
import Lottie from 'lottie-react'

import animationData from '@plvs/respawn/assets/lottie/flame_ring.json'

interface HotstreakProps {
  streakLength?: number | null
  size?: 'xs' | 'small' | 'medium' | 'large' | 'xl'
}

const MIN_STREAK_LENGTH = 3
const ZINDEX = 1000
const SIZES = {
  xs: {
    height: 120,
    width: 120,
  },
  small: {
    height: 120,
    width: 120,
  },
  medium: {
    height: 200,
    width: 200,
  },
  large: {
    height: 180,
    width: 180,
  },
  xl: {
    height: 500,
    width: 500,
  },
}

export const Hotstreak: React.FC<HotstreakProps> = ({
  streakLength = 0,
  size = 'medium',
}) => {
  if (!streakLength || (streakLength && streakLength < MIN_STREAK_LENGTH)) {
    return <></>
  }

  switch (size) {
    case 'xs': {
      return (
        <Box ml="-35px" mt="-32px" position="absolute" zIndex={ZINDEX}>
          <Lottie
            animationData={animationData}
            style={{ height: SIZES.xs.height, width: SIZES.xs.width }}
          />
        </Box>
      )
    }
    case 'small': {
      return (
        <Box ml="-32px" mt="-30px" position="absolute" zIndex={ZINDEX}>
          <Lottie
            animationData={animationData}
            style={{ height: SIZES.small.height, width: SIZES.small.width }}
          />
        </Box>
      )
    }
    case 'large': {
      return (
        <Box ml="-53px" mt="-49px" position="absolute" zIndex={ZINDEX}>
          <Lottie
            animationData={animationData}
            style={{ height: SIZES.large.height, width: SIZES.large.width }}
          />
        </Box>
      )
    }
    case 'xl': {
      return (
        <Box position="relative">
          <Lottie
            animationData={animationData}
            style={{
              height: SIZES.xl.height,
              width: SIZES.xl.width,
              position: 'absolute',
              top: -120,
              left: -131,
              zIndex: ZINDEX,
            }}
          />
        </Box>
      )
    }
    case 'medium':
    default:
      return (
        <Box position="relative">
          <Lottie
            animationData={animationData}
            style={{
              height: SIZES.medium.height,
              width: SIZES.medium.width,
              position: 'absolute',
              top: -133,
              left: -69,
              zIndex: ZINDEX,
            }}
          />
        </Box>
      )
  }
}
